import { HttpErrorResponse } from '@angular/common/http';
import * as fromGenerated from '../../_generated';

// Imported by its path, never through the `chats/assistants` barrel: that
// barrel is cyclic and a new import there can close a loop.

/** The default chat locks the API refuses with a named 409 (SB-3944, KD-14). */
export const DEFAULT_CHAT_LOCK_KEYS: Readonly<Record<string, string>> = {
  ASSISTANT_IS_DEFAULT_CHAT_ERROR:
    'ASSISTANTS.DEFAULT_CHAT_LOCK.DELETE_REFUSED',
  ACCESS_CONTROL_DEFAULT_CHAT_ORG_WIDE_GRANT_LOCKED_ERROR:
    'ASSISTANTS.DEFAULT_CHAT_LOCK.ORG_WIDE_REFUSED',
  ADMIN_UPDATE_USER_ROLE_OWNS_DEFAULT_CHAT:
    'ASSISTANTS.DEFAULT_CHAT_LOCK.ROLE_REFUSED',
};

/** The API's error name: AppExceptionFilter puts it at the top of the body. */
export const readApiErrorName = (error: unknown): string | undefined => {
  if (!(error instanceof HttpErrorResponse)) return undefined;
  const body: unknown = error.error;
  const name =
    typeof body === 'object' && body !== null
      ? (body as { name?: unknown }).name
      : undefined;
  return typeof name === 'string' ? name : undefined;
};

/** The key for a default chat lock refusal; undefined for every other name. */
export const defaultChatLockKey = (
  name: string | null | undefined,
): string | undefined =>
  name != null && Object.hasOwn(DEFAULT_CHAT_LOCK_KEYS, name)
    ? DEFAULT_CHAT_LOCK_KEYS[name]
    : undefined;

/** Whether the skill is the organization's default chat. */
export const isDefaultChatSkill = (
  skill: fromGenerated.AssistantView | null | undefined,
): boolean => skill?.isDefaultChat === true;
